import { getDisableTimeOnly } from '@/utils';
import React, { memo, useCallback } from 'react';

import type { DatePickerProps } from 'antd';
import type { Dayjs } from 'dayjs';
import { Field, FieldProps } from 'formik';

import TimePicker from '../time-picker';

interface IDatePickerProps extends DatePickerProps {
	format?: any;
	values?: any;
	startTimeKey?: string;
	endTimeKey?: string;
}

const TimeRangePicker: React.FC<IDatePickerProps> = ({
	name,
	values,
	format,
	startTimeKey = '',
	endTimeKey = '',
	...rest
}) => {
	const disabledStartTime = useCallback(
		(current: Dayjs) => {
			return getDisableTimeOnly(current, values?.[endTimeKey], true);
		},
		[values?.[endTimeKey]]
	);

	const disabledEndTime = useCallback(
		(current: Dayjs) => {
			return getDisableTimeOnly(current, values?.[startTimeKey], false);
		},
		[values?.[startTimeKey]]
	);

	return (
		<Field name={`${startTimeKey}-${endTimeKey}`}>
			{({
				field,
				form: { setFieldValue, errors, touched },
				meta,
			}: FieldProps) => {
				return (
					<div className="flex items-center justify-center">
						<TimePicker
							{...rest}
							key={startTimeKey}
							id={startTimeKey}
							name={startTimeKey}
							format={format}
							showTime
							disabledTime={disabledStartTime}
							value={values?.[startTimeKey]}
							onChange={(value, valueString) => {
								setFieldValue(startTimeKey, valueString);
							}}
							allowClear={true}
							touched={!!touched?.[startTimeKey]}
							errorCode={errors?.[startTimeKey] as string}
						/>
						<span className="px-2">-</span>
						<TimePicker
							{...rest}
							key={endTimeKey}
							id={endTimeKey}
							name={endTimeKey}
							format={format}
							showTime
							disabledTime={disabledEndTime}
							value={values?.[endTimeKey]}
							onChange={(value, valueString) => {
								setFieldValue(endTimeKey, valueString);
							}}
							allowClear={true}
							touched={!!touched?.[endTimeKey]}
							errorCode={errors?.[endTimeKey] as string}
						/>
					</div>
				);
			}}
		</Field>
	);
};

export default memo(TimeRangePicker);
